export default "__VITE_ASSET__4llO3P6L__"